.SelectLabel {
  z-index: 1;
  cursor: pointer;
  display: grid;
  grid: auto auto / 1fr;
  gap: var(--space-xs);
  border-radius: 5px;
  border: 1px solid var(--neutral-1);
  padding: var(--space-sm);
  background: var(--white);
  transition: border-color 150ms;

  span:first-of-type {
    font-size: 0.8125rem;
    color: var(--neutral);
  }

  &:hover {
    border-color: var(--neutral);
    box-shadow: var(--smooth-shadow);
  }

  &:has(.Select:disabled),
  &:has(.Select[aria-readonly="true"]) {
    pointer-events: none;
    cursor: default;
    background-color: var(--disabled-background);
    border-color: var(--neutral-1);
    box-shadow: none;

    span:first-of-type {
      color: var(--neutral-1);
    }
  }

  &:has(.Select[aria-invalid="true"]) {
    border-color: var(--accent-2);
  }

  &:focus-within {
    border-color: var(--neutral);
    box-shadow: var(--smooth-shadow);
    transition: border-color 150ms;
  }

  .Select {
    appearance: none;
    width: 100%;
    border: none;
    font-size: inherit;
    background: url("assets/arrow.svg");
    background-repeat: no-repeat;
    background-position: right center;
    background-size: 7px;
    padding-right: var(--space-md);
    color: var(--black);
    text-overflow: ellipsis;

    &:not(:disabled):hover {
      background-image: url("assets/arrow-hover.svg");
      cursor: pointer;
    }

    &:disabled {
      opacity: 1;
      color: var(--disabled-color);
    }

    &:focus-visible,
    &:focus {
      outline: none;
    }
  }
}
